"use client";

import Link from "next/link";
import HomeCreateCommunity from "../home/_components/HomeCreateCommunity";
import { Button } from "~/components/v4/themed/Button";
import { useState } from "react";
import { useLaunchCommunity } from "~/hooks/useLaunchCommunity";
import LoginModal from "~/components/v3/themed/LoginModal";
import { ButtonLink } from "~/components/v3/themed/Button";
import { useSession } from "next-auth/react";
import { useRouter } from "next/navigation";

export const FooterCreateEventButton = () => {
    const router = useRouter();
    const [isEventsModalOpen, setIsEventsModalOpen] = useState(false);
    const session = useSession();

    return (
        <div className="hidden flex-row items-center space-x-2 lg:flex">
            <button
                className="cursor-pointer transition-colors hover:text-white/80"
                onClick={() => {
                    if (session.data?.user) {
                        router.push("/beta/events/create");
                    } else {
                        setIsEventsModalOpen(true);
                    }
                }}
            >
                Host your event free on River
            </button>
            <LoginModal
                isOpen={isEventsModalOpen}
                setIsOpen={setIsEventsModalOpen}
                title="Sign in to create an event"
                description="Create your event page and start hosting events."
                callbackUrl="/beta/events/create"
            />
        </div>
    );
};
